import { takeLatest, put } from 'redux-saga/effects';

import {
  contaBancoCadastro,
  NEW_CONTA_BANCO_CADASTRO,
  NEW_CONTA_BANCO_CADASTRO_SUCCESS,
} from '@handler';

function* sagaNewContaBancoCadastro(action) {

  yield put({ 
    type: NEW_CONTA_BANCO_CADASTRO_SUCCESS, 
    registro: contaBancoCadastro.newRegistro,
    isCadastroRapido: action.isCadastroRapido,
  });
}

export default function* watchNewContaBancoCadastro() {
  yield takeLatest(NEW_CONTA_BANCO_CADASTRO, sagaNewContaBancoCadastro)
}
